export class AiImageGenerationModel {
  // width: number|undefined=undefined;
  // height: number|undefined=undefined;
  reference_image : File | null=null;
  prompt!: string;
  pattern!:string;
}


